import React from "react";
import { connect } from "react-redux";

import { isAnyPendingParentalConsentItemFailed } from "state/school_money/selectors";
import { clearFailedPendingParentalConsentItems } from "state/school_money/actions";

import ModalDialog from "components/ModalDialog";
import Button from "components/Button";

import "./ParentalConsentErrorModal.css";

class ParentalConsentErrorModal extends React.Component {
  
  render() {
    return (
      <ModalDialog isOpen={this.props.isOpen}>
        <div className="parental-consent-error">
          <div className="parental-consent-error__title">Oops!</div>
          <div className="parental-consent-error__message">
            Sorry! Something went wrong and your consent could not be saved. Please try again later.
          </div>
          <div className="parental-consent-error__button-container">
            <Button className="parental-consent-error__close-button" onClick={this.props.onClose}>OK</Button>
          </div>
        </div>
      </ModalDialog>
    );
  }
  
}

export default connect(
  state => ({
    isOpen: isAnyPendingParentalConsentItemFailed(state)
  }),
  {
    onClose: clearFailedPendingParentalConsentItems
  }
)(ParentalConsentErrorModal);



// WEBPACK FOOTER //
// ./src/components/school_money/parental_consent/ParentalConsentErrorModal.js